import { render, staticRenderFns } from "./HodOnboardingOverviewPage.vue?vue&type=template&id=3200855b&scoped=true&"
import script from "./HodOnboardingOverviewPage.vue?vue&type=script&lang=ts&"
export * from "./HodOnboardingOverviewPage.vue?vue&type=script&lang=ts&"
import style0 from "./HodOnboardingOverviewPage.vue?vue&type=style&index=0&id=3200855b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3200855b",
  null
  
)

export default component.exports